var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2442 8.30613H9.84317C6.61584 8.30613 4 10.9234 4 14.1526C4 17.3817 6.61584 20 9.84317 20H13.5657C14.1524 20 14.6276 19.5236 14.6276 18.9365C14.6276 18.3495 14.1524 17.8741 13.5657 17.8741H9.84317C7.78919 17.8741 6.1247 16.2077 6.1247 14.1525C6.1247 12.0974 7.78919 10.432 9.84317 10.432H17.2442L14.8455 12.8319C14.4093 13.2675 14.4093 13.9751 14.8455 14.4107C15.2808 14.8462 15.9871 14.8462 16.4234 14.4107L20.6728 10.1579C21.1091 9.72234 21.1091 9.01569 20.6728 8.57916L16.4234 4.3274C15.9871 3.89087 15.2808 3.89087 14.8455 4.3274C14.4093 4.76293 14.4093 5.46959 14.8455 5.90612L17.2442 8.30613Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.5a15bb0d5e67f5c2a2a374ef1227ea42.svg";
export { ForwardRef as ReactComponent };